import React from 'react'; 
import styles from './BlockContainer.module.scss'; 

export default function BlockContainer() {

    return (
        <div className={styles["container"]}></div>
    )
}